import { Component } from '@angular/core';

@Component({
  selector: 'app-summary-option',
  template: `
    <div
      class="tw-col-span-2 tw-flex tw-items-center tw-justify-center tw-pb-[20px] tw-pt-[10px]"
    >
      <span class="tw-text-[var(--sed-black-80-color)]"
        >No conditions required</span
      >
    </div>
  `,
  styles: ``,
})
export class SummaryOptionComponent {}
